// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header__gTehV","main":"layout_main__2Ivh6","container":"layout_container__F3WlY"};